const parseBoolean = (value: string | undefined, key: string): boolean => {
  if (value === undefined || value === '') return false;
  if (value === 'true' || value === '1') return true;
  if (value === 'false' || value === '0') return false;
  throw new Error(
    `Invalid value for ${key}: ${JSON.stringify(value)}. Expected "true" or "false".`
  );
};

const parseFaroUrl = (value: string | undefined): string | undefined => {
  const raw = value ?? '';
  if (!raw) return undefined;
  try {
    new URL(raw);
  } catch {
    throw new Error(`VITE_FARO_URL is not a valid URL: ${JSON.stringify(raw)}`);
  }
  return raw.replace(/\/$/, '');
};

const parseBaseUrl = (value: string | undefined): string => {
  const raw = value ?? '';
  if (!raw) {
    if (import.meta.env.DEV) return 'http://localhost:8080';
    throw new Error('VITE_API_BASE_URL is required in production builds.');
  }
  try {
    new URL(raw);
  } catch {
    throw new Error(`VITE_API_BASE_URL is not a valid URL: ${JSON.stringify(raw)}`);
  }
  return raw.replace(/\/$/, '');
};

export const env = {
  apiBaseUrl: parseBaseUrl(import.meta.env.VITE_API_BASE_URL),
  useMock:
    (import.meta.env.DEV || import.meta.env.MODE === 'e2e') &&
    parseBoolean(import.meta.env.VITE_USE_MOCK, 'VITE_USE_MOCK'),
  e2eMode:
    (import.meta.env.DEV || import.meta.env.MODE === 'e2e') &&
    parseBoolean(import.meta.env.VITE_E2E_MODE, 'VITE_E2E_MODE'),
  telemetryEnabled: parseBoolean(import.meta.env.VITE_TELEMETRY_ENABLED, 'VITE_TELEMETRY_ENABLED'),
  faroUrl: parseFaroUrl(import.meta.env.VITE_FARO_URL),
  appEnv: import.meta.env.VITE_ENV || 'development',
  appVersion: import.meta.env.VITE_APP_VERSION || 'dev',
} as const;
